import React, { useEffect } from 'react';
import GeneralLayout from '../../layouts/general';
import GetADemoGuide from '../../components/GetADemoGuide';
import Head from 'next/head';
import { mixpanel } from '../../third_party/Mixpanel';
import { ROICalculator } from 'src/components/POSWebsite/ROICalculator';

const PageGetADemo = () => {
  useEffect(() => {
    mixpanel.track({ enableTracking: true, name: 'website/get-a-demo_page' });
  }, []);

  return (
    <>
      <Head>
        <meta httpEquiv="Content-type" content="text/html; charset=UTF-8" />
      </Head>
      <GeneralLayout pageId="pos-get-a-demo">
        <div className="container common-section">
          <GetADemoGuide showSkipNow={false} />
        </div>
        <ROICalculator />
      </GeneralLayout>
    </>
  );
};

export default PageGetADemo;

export async function getStaticProps(context) {
  return {
    props: {}, // will be passed to the page component as props
  };
}
